import checkIsValidEmail from 'utils/checkIsValidEmail';

type Props = {
  extraSignerName: string;
  extraSignerEmail: string;
};

export default function isValidExtraSigner({
  extraSignerName,
  extraSignerEmail,
}: Props): boolean {
  const validName = extraSignerName !== '';
  const validEmail = checkIsValidEmail(extraSignerEmail);
  return validName && validEmail;
}
